import { Component, input, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColDef } from 'ag-grid-enterprise';

import { ErsGridComponent } from '@rcs/grid';
import { formatDateMDY } from '../../utils/date.utils';
import { TakenCompOff } from '../../models/leave.model';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ers-leave-holiday-panel',
  standalone: true,
  imports: [
    TranslocoPipe,CommonModule, ErsGridComponent],
  templateUrl: './leave-holiday-panel.component.html',
  styleUrls: ['./leave-holiday-panel.component.scss'],
})
export class LeaveHolidayPanelComponent {
  /** Grid data for each tab */
  companyHolidayRows = input<any[]>([]);
  optionalHolidayRows = input<any[]>([]);
  pendingWorkedRows = input<any[]>([]);

  /** Column definitions */
  holidayColDefs = input<ColDef[]>([]);
  workedDateColDefs = input<ColDef[]>([]);

  /** Taken CompOff entries — only request-leave-page passes real data */
  takenCompOffs = input<TakenCompOff[]>([]);

  /**
   * When `true`, the "Taken Compoff" card is rendered inside the Compoff tab.
   * Only request-leave-page needs this; gift/avail pages keep default `false`.
   */
  showTakenCompOffCard = input(false);

  /**
   * Externally controlled active tab index. Allows the parent to programmatically
   * switch tabs (e.g. request-leave-page syncing with the left-panel tab switch).
   * The user can still click tabs freely; external changes override the selection.
   */
  activeTab = input(0);

  /** Internal tab state driven by clicks and the `activeTab` input */
  currentTab = 0;

  constructor() {
    effect(() => {
      this.currentTab = this.activeTab() ?? 0;
    });
  }

  // ─── Formatting helpers (mirrors request-leave-page) ─────────────────────

  private fmt(d: string | Date): string {
    return formatDateMDY(d);
  }

  formatTakenWorkedRange(tc: TakenCompOff): string {
    const from = this.fmt(tc.workedDateFrom);
    const to = tc.workedDateTo ? this.fmt(tc.workedDateTo) : null;
    return to && to !== from ? `${from} - ${to}` : from;
  }

  formatTakenRequestedRange(tc: TakenCompOff): string {
    const from = this.fmt(tc.requestedDateFrom);
    const to = tc.requestedDateTo ? this.fmt(tc.requestedDateTo) : null;
    return to && to !== from ? `${from} - ${to}` : from;
  }
}
